import { GeckoEditableFeature } from 'types/assetModel/features/baseClasses/geckoEditableFeature'
import { GeckoComponentCoords } from 'types/geometric/geckoComponentCoords'

import { PipeIntegralSupportType } from './geckoPipeIntegralSupport'
import { PipeNonIntegralSupportType } from './geckoPipeNonIntegralSupport'

export class GeckoPipeSupport extends GeckoEditableFeature {
  readonly name: string | undefined
  readonly pipeSupportType:
    | PipeNonIntegralSupportType
    | PipeIntegralSupportType
    | undefined
  readonly geometry: GeckoComponentCoords

  constructor(
    name: string | undefined,
    pipeSupportID: string,
    pipeSupportType:
      | PipeNonIntegralSupportType
      | PipeIntegralSupportType
      | undefined,
    geometry: GeckoComponentCoords
  ) {
    super(pipeSupportID)
    this.name = name
    this.pipeSupportType = pipeSupportType
    this.geometry = geometry
  }
}
